<template>
    <sa-page-layout :pathResource="pathResource" :showmolalloading="showmolalloading">
        <template slot="toolbar"></template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <home-botox-list-component></home-botox-list-component>
            </div>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import HomeBotoxListComponent from "../components/HomeBotoxListComponent.vue";
export default {
    components: { SaPageLayout, HomeBotoxListComponent },
    created() {},
    data() {
        return {
            showmolalloading: false,
            pathResource: "/ambulatoriutenti",
        };
    },
};
</script>
<style lang="css">
.sa-logo-home img {
    width: 100%;
    max-width: 35rem;
}
</style>
>
